import { render, staticRenderFns } from "./IconTiktok.vue?vue&type=template&id=b156ca2e"
import script from "./IconTiktok.vue?vue&type=script&lang=js"
export * from "./IconTiktok.vue?vue&type=script&lang=js"
import style0 from "./IconTiktok.vue?vue&type=style&index=0&id=b156ca2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports